import { render, staticRenderFns } from "./MadeAPurchaseMT.vue?vue&type=template&id=bf8337fc&scoped=true&"
import script from "./MadeAPurchaseMT.vue?vue&type=script&lang=js&"
export * from "./MadeAPurchaseMT.vue?vue&type=script&lang=js&"
import style0 from "./MadeAPurchaseMT.vue?vue&type=style&index=0&id=bf8337fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8337fc",
  null
  
)

export default component.exports